import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";

export default function SsoCallbackPage() {
  const { loginSso } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("processing");
  const [errorMsg, setErrorMsg] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(location.search);
    const ssoToken = params.get("sso");
    const stateFromUrl = params.get("state");
    const expectedState = sessionStorage.getItem("tk_sso_state");

    if (!ssoToken) {
      setErrorMsg("Token SSO mancante.");
      setStatus("error");
      return;
    }
    if (expectedState && stateFromUrl && stateFromUrl !== expectedState) {
      setErrorMsg("State CSRF non valido.");
      setStatus("error");
      return;
    }
    sessionStorage.removeItem("tk_sso_state");

    (async () => {
      const res = await loginSso(ssoToken);
      if (!res.success) {
        setErrorMsg(res.error || "Verifica SSO fallita.");
        setStatus("error");
        return;
      }
      setStatus("success");
      const role = res.data?.role;
      let target = "/";
      if (role === "superadmin") target = "/superadmin";
      else if (role === "casa_madre") target = "/casa-madre";
      else if (role === "rivenditore") target = "/rivenditore";
      else if (role === "customer") target = "/account";
      setTimeout(() => navigate(target, { replace: true }), 600);
    })();
  }, [location.search, loginSso, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAFAFA]" data-testid="sso-callback-page">
      <div className="bg-white rounded-sm border border-border max-w-md w-full p-10 text-center">
        {status === "processing" && (
          <>
            <Loader2 className="w-12 h-12 text-brand mx-auto mb-4 animate-spin" />
            <h1 className="font-heading font-bold text-2xl mb-2">Verifica TotalKlick in corso…</h1>
            <p className="text-sm text-muted-foreground">Stiamo confermando la tua identità con l'IdP centralizzato.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
            <h1 className="font-heading font-bold text-2xl mb-2">Accesso effettuato</h1>
            <p className="text-sm text-muted-foreground">Reindirizzamento alla dashboard…</p>
          </>
        )}
        {status === "error" && (
          <>
            <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="font-heading font-bold text-2xl mb-2">Verifica SSO fallita</h1>
            <p className="text-sm text-muted-foreground mb-6">{errorMsg}</p>
            <button
              data-testid="sso-back-login"
              onClick={() => navigate("/login", { replace: true })}
              className="px-5 py-2.5 rounded-sm bg-[#0A0A0A] text-white text-sm font-medium hover:bg-[#1f1f1f] transition-colors"
            >
              Torna al login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
